<template>
  <order-body :isOk="false" :codeStatus="700" :pageText="'orderTransferred'"></order-body>
</template>

<script>
import orderBody from "_my/order-body";

export default {
  name: "orderTransferred",
  components: {
    orderBody,
  },
};
</script>